import styled, { css } from 'styled-components';

import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  position: relative;
`;

const transitionJump = css`
  && {
    transition-property: background-color, padding;
    transition-duration: var(--transition-duration);
    transition-timing-function: var(--transition-fn);
  }
`;
interface ILine {
  blocked: boolean;
}

export const Line = styled.div<ILine>`
  display: flex;
  align-items: center;
  cursor: ${({ blocked }) => (blocked ? 'not-allowed' : 'pointer')};
  ${transitionJump}
  height: 40px;
  padding-left: 8px;

  :hover {
    background: ${beam.background.card};
    border-color: ${beam.background.card};
    border-radius: 8px;
    position: unset;
    padding-left: 12px;
    padding-right: 8px;
  }
`;
Line.displayName = 'Line';
export const Avatar = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 12px;
  margin-right: 8px;
`;
Avatar.displayName = 'Avatar';
interface IText {
  blocked: boolean;
}

export const Text = styled.div<IText>`
  color: #474d66;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  height: 42px;
  cursor: ${({ blocked }) => (blocked ? 'not-allowed' : 'pointer')};
`;
Text.displayName = 'Text';
interface IEmpty {
  blocked: boolean;
}

export const Empty = styled.div<IEmpty>`
  color: #c1c4d6;
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
  padding-left: 8px;
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  cursor: ${({ blocked }) => (blocked ? 'not-allowed' : 'pointer')};
  ${transitionJump}
  :hover {
    background: ${beam.background.card};
    border-color: ${beam.background.card};
    border-radius: 8px;
    position: unset;
    padding-left: 12px;
    padding-right: 8px;
  }
`;
Empty.displayName = 'Empty';
